import esMessages from "./es.json"
import caMessages from "./ca.json"
import enMessages from "./en.json"

export const messages = {
	es: esMessages,
	ca: caMessages,
	en: enMessages,
} as const

export type Locale = keyof typeof messages
export const locales = Object.keys(messages) as Locale[]
export const defaultLocale: Locale = "ca"
